import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { navigationService } from 'vue-spatialnavigation';
import type {ImageAspect} from '@/components/TG4Image.vue';
import { RailResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import { useCMSItemNavigation } from '@/composables/useCMSItemNavigation';
import TG4Image from '@/components/TG4Image.vue';
import QRCodeModal from '@/components/QRCodeModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketingRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};




const { itemId, handleUp, handleDown, handleLeftFallback } = useRailNavigation(props);
const { openItem } = useCMSItemNavigation();

const instance = getCurrentInstance();
const router = instance?.proxy?.$router;
const route = computed(() => instance?.proxy?.$route);

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const isIrish = computed(() => currentLanguage.value === Language.Irish);

const localised = (en: string | null, ga: string | null) => {
  const value = isIrish.value ? ga : en;
  return value ?? en ?? '';
};

const title = computed(() => localised(props.rail.titleEn, props.rail.titleGa));
const subtitle = computed(() => localised(props.rail.subtitleEn, props.rail.subtitleGa));
const actionButtonText = computed(() =>
  localised(props.rail.actionButtonTextEn, props.rail.actionButtonTextGa)
);


const aspect = computed<ImageAspect>(() => {
  switch (props.rail.railAspect) {
    case '32:9':
      return 'banner';
    case '64:9':
      return 'banner_thin';
    default:
      return 'banner';
  }
});

const buttonOnLeft = computed(() => props.rail.actionButtonPosition === 'LEFT');

const item = computed(() => props.rail.items[0] ?? null);

const showActionButton = computed(() => Boolean(props.rail.actionButtonUrl) || item.value !== null);

const textStyle = computed(() => ({
  color: props.rail.textColor ?? undefined,
}));


const buttonStyle = computed(() => ({
  'background-color': props.rail.backgroundColor ?? undefined,
  color: props.rail.textColor ?? undefined,
}));


//Hash per rail Id
const qrHash = computed(() => `showQRCode-${props.rail.id}`);

const showQRCode = computed(() => route.value?.hash === `#${qrHash.value}` );

const handlePress = () => {
  if (props.rail.actionButtonUrl) {
    router?.push({ path: router.currentRoute.path, hash: qrHash.value });
    return;
  }

  if (item.value) openItem(item.value);
};

const closeQRCode = () => {
  router?.back();
};

//Refocus on rail once closing modal if Ids match
watch(() => route.value?.hash, (newHash, oldHash) => {
  if (newHash || oldHash !== `#${qrHash.value}`) return;

  setTimeout(() => {
    const element = navigationService.getFocusElementById(itemId(0));
    if (element) element.focus();
  }, 100);
});

const rootRef = ref<HTMLElement | null>(null);
const lazyLoad = instance?.proxy?.$lazyLoad;


const scanForLazyImages = () => {
  setTimeout(() => {
    if (rootRef.value) lazyLoad?.(rootRef.value);
  }, 200);
};

onMounted(scanForLazyImages);


return { __sfc: true,props, itemId, handleUp, handleDown, handleLeftFallback, openItem, instance, router, route, useGetter, currentLanguage, isIrish, localised, title, subtitle, actionButtonText, aspect, buttonOnLeft, item, showActionButton, textStyle, buttonStyle, qrHash, showQRCode, handlePress, closeQRCode, rootRef, lazyLoad, scanForLazyImages, TG4Image, QRCodeModal }
}

})